// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-data-iterator__pagination{margin-top:1rem}@media(min-width:768px){.v-data-iterator__pagination{margin-top:1.875rem}}@media(max-width:767.98px){.v-data-iterator__pagination{justify-content:center}}.v-data-iterator__items-wrapper{position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
